import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_Link;

const FreezingRequestServices = {
  // Public (no auth header)
  publicBranches: () =>
    axios.get(`${API_URL}/public/freezing-requests/branches`),

  publicValidate: (payload) =>
    axios.post(`${API_URL}/public/freezing-requests/validate`, payload),

  publicSubmit: (payload) =>
    axios.post(`${API_URL}/public/freezing-requests/submit`, payload),

  // Authenticated
  list: (params) =>
    axios.get(`${API_URL}/freezing-requests/`, {
      params,
      headers: authHeader(),
    }),

  approve: (id, admin_notes) =>
    axios.post(
      `${API_URL}/freezing-requests/${id}/approve`,
      { admin_notes },
      { headers: authHeader() }
    ),

  decline: (id, admin_notes) =>
    axios.post(
      `${API_URL}/freezing-requests/${id}/decline`,
      { admin_notes },
      { headers: authHeader() }
    ),
};

export default FreezingRequestServices;
